import styled from 'styled-components';

export const TutorialPlayIconStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background: var(--color-white-95);
    color: var(--color-tertiary);
    
    &.lg {
        width: 40px;
        height: 40px;
        border-radius: 20px;
    }
    
    &.is-seen {
        color: var(--color-tertiary-30);
    }
`;
